import React from 'react';
import SEO from '../components/seo';

const AAANewMemberJourney: React.FC<any> = () => {
  return (
    <div style={{ margin: 0, padding: 0, overflow: 'hidden' }}>
      <SEO
        title="Welcome to AAA | Here's how to make the most of your AAA Membership."
        description="AAA is trusted by 2.1 Million Carolinians."
        canonicalUrl="/new-member-journey"
      />

      <iframe
        width="100vw"
        src="https://prod-carolinas-aaa-com.azurewebsites.net/new-member-journey/"
        frameBorder="0"
        style={{
          overflow: 'hidden',
          height: '100vh',
          width: '100%',
          display: 'block',
        }}
      ></iframe>
    </div>
  );
};

export default AAANewMemberJourney;
